// extracted by mini-css-extract-plugin
export default {"arrowLink":"_f2367091","left":"_808b35b3","right":"_d89c4588","up":"_d7fe1f4d","down":"_da30cdda","arrow":"_faf44131","arrowFiller":"_177e3969"};